export const architectureWorkspaceKeys = {
  all: ["architecture-workspace"] as const,
  singleton: () => [...architectureWorkspaceKeys.all, "singleton"] as const,
};
